export { default } from './SectionThumbnail';



// WEBPACK FOOTER //
// ./src/components/trending/SectionThumbnail/index.js